"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Photo = void 0;
const Image_1 = require("./Image");
const CommonDto_1 = require("../dto/CommonDto");
class Photo {
    constructor(uploadId, tq, lq = null, mq = null, hq = null) {
        this.type = CommonDto_1.PhotoType.PHOTO;
        this.uploadId = 0;
        this.uploadId = uploadId;
        this.tq = tq;
        this._lq = lq ? this._lq = lq : null;
        this._mq = mq ? this._mq = mq : null;
        this._hq = hq ? this._hq = hq : null;
    }
    copy() {
        return new Photo(this.uploadId, this.tq, this._lq, this._mq, this._hq);
    }
    static copy(source, target) {
        target.uploadId = source.uploadId;
        Image_1.Image.copy(source.tq, target.tq);
        source._lq ? Image_1.Image.copy(source._lq, Image_1.Image.createEmpty()) : target._lq = null;
        source._mq ? Image_1.Image.copy(source._mq, Image_1.Image.createEmpty()) : target._mq = null;
        source._hq ? Image_1.Image.copy(source._hq, Image_1.Image.createEmpty()) : target._hq = null;
        return target;
    }
    static createEmpty() {
        return new Photo(0, Image_1.Image.createEmpty());
    }
    static photoId(uploadId) {
        const photo = this.createEmpty();
        photo.uploadId = uploadId;
        return photo;
    }
    static fromDto(photoDto) {
        return new Photo(photoDto.uploadId, Image_1.Image.fromDto(photoDto.tq), Image_1.Image.fromOptionalDto(photoDto.lq), Image_1.Image.fromOptionalDto(photoDto.mq), Image_1.Image.fromOptionalDto(photoDto.hq));
    }
    toDto() {
        return {
            type: CommonDto_1.PhotoType.ID,
            uploadId: this.uploadId
        };
    }
    get lq() {
        return this._lq ? this._lq : this.tq;
    }
    get mq() {
        return this._mq ? this._mq : this.lq;
    }
    get hq() {
        return this._hq ? this._hq : this.mq;
    }
}
exports.Photo = Photo;
